import React from 'react';
import styled from 'styled-components';
import { generateRandomNum } from 'services/data-utils';

import Button from 'components/Button/Button';

import { media } from 'styles/breakpoints';

const trumpShocked = require('styles/images/trump-shocked.gif');

const NotFoundMessages = [
  "Just like Donald Trump, this page isn't ready for prime time. Hang tight while we make it great again.",
  "Sorry, it looks like we were targeted by Russian hackers for mentioning Trump's ties to Russian hookers. Head back to the main page to try again. Спасибо",
  "We may have spent more time preparing for this website than Trump did preparing for the presidency, but that isn't really saying much. Head back to the main page while we try to make this site great again.",
  "We may have the best words, but unfortunately they're not on this page. Head back to the main page which is really terrific. Everyone agrees."
];

const Container = styled.div`
  margin: 20px;
  padding-bottom: 50px;
  text-align: center;
`;

// TODO: Refactor into shared Header Component
const Header = styled.h1`
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  margin: 45px 0;
  text-align: center;
`;

// TODO: Refactor into shared Text Component
const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
  text-align: justify;
  margin: 40px 0;

  ${media.small`
    margin: 60px 20px;
  `} ${media.medium`
    max-width: 50%;
    margin: 60px auto;
  `};
`;

const Image = styled.img`
  display: block;
  margin: 0 auto;
`;

export default function NotFound() {
  const textToRender =
    NotFoundMessages[generateRandomNum(0, NotFoundMessages.length - 1)];
  return (
    <Container>
      <Header>
        Oops. This page must be hiding with the Donald's tax returns
      </Header>
      <Image alt="Trump Shocked" src={trumpShocked} />
      <Text>{textToRender}</Text>
      <Button to="/">Go Home</Button>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/views/NotFound.js